export const getTeamOrUserName = (actor, teamOriginalActor) =>
  teamOriginalActor ? `(${actor}), ${teamOriginalActor}` : actor;



// WEBPACK FOOTER //
// ./src/utils/ui/getTaemOrUserName.js